import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NoteForApproversSection', {
    label: 'Note for Approvers',
    placeholder: 'Enter comment...',
    maxLength:
        'Note to Approvers length limit ({maxLength} characters) is exceeded due to formatting. Please remove the formatting and try again.',
    required: 'Note for Approvers is mandatory',
});
